import functionsDataResumen from "./functionsDataResumen";

const datesAndLocations = (state, data) => {
  ////////////Fecha de la Denuncia/////////////
  try {
    //si la fecha de la denuncia viene del store, esta sera de formato objet y habra que convertirla
    if (typeof state.fechaDenuncia == "object") {
      data.fechaCertificadoDenuncia = state.fechaDenuncia.toLocaleDateString("es-AR");
    } //caso contrario, si viene de la Bd vendra en formato string
    else {
      data.fechaCertificadoDenuncia = state.fechaDenuncia;
    }

    if (state.fechaDenuncia != null) {
      let formattedDate = state.fechaDenuncia;
      let datosDeExtCertificado = new Date(formattedDate);
      data.año = datosDeExtCertificado.getFullYear();
      data.horaDeExtCertificado =
        datosDeExtCertificado.getHours() +
        ":" +
        datosDeExtCertificado.getMinutes() +
        ":" +
        datosDeExtCertificado.getSeconds();
    } else {
      let datosDeExtCertificado = new Date();
      data.año = datosDeExtCertificado.getFullYear();
      data.horaDeExtCertificado =
        datosDeExtCertificado.getHours() +
        ":" +
        datosDeExtCertificado.getMinutes() +
        ":" +
        datosDeExtCertificado.getSeconds();
    }
  } catch (e) {
    console.log("Error al cargar la fecha de la Denuncia. EROOR: " + e);
  }

  ///////////////////////////Fecha y hora del Hecho//////////////////////
  try {
    let date = state.moment.date;
    let date2 = state.moment.date2;
    var dateActual = new Date();
    ////////cargo la fecha y hora 1-Desde///////
    if ((typeof date == "string" || typeof date == "object") && date != null && date != undefined) {
      date = new Date(date);
      data.fechaDelHecho1 = date.toLocaleDateString("es-AR"); //esto ya la trae en formato slash
      data.fechaDelHechoText1 = functionsDataResumen.fechaLetras(date);
      data.horaDelHecho1 = date.toLocaleTimeString("es-AR");
    }

    ///////////cargo fecha y hora 2-Hasta////////////
    if ((typeof date2 == "string" || typeof date2 == "object") && date2 != null) {
      date2 = new Date(date2);
      date = new Date(date);
      data.fechaDelHecho2 = date2.toLocaleDateString("es-AR"); //esto ya la trae en formato slash
      data.fechaDelHechoText2 = functionsDataResumen.fechaLetras(date2);
      data.horaDelHecho2 = date2.toLocaleTimeString("es-AR");
    }
    if (date == null && date2 != null) {
      //si uno esta indefinido, tomamos el valor del otro
      data.fechaDelHecho = data.fechaDelHecho2;
      data.horaDelHecho = data.horaDelHecho2;
      data.fechaDelHechoText = data.fechaDelHechoText2;
    }
    if (date != null && date2 == null) {
      //si uno esta indefinido, tomamos el valor del otro
      data.fechaDelHecho = data.fechaDelHecho1;
      data.horaDelHecho = data.horaDelHecho1;
      data.fechaDelHechoText = data.fechaDelHechoText1;
    }
    if (date != null && date === date2) {
      // si ambos son iguales
      data.fechaDelHecho = data.fechaDelHecho1; //cualquiera de las 2 es lo mismo seleccionamos cualquiera de ellos
      data.horaDelHecho =
        data.horaDelHecho1 < data.horaDelHecho2
          ? `${data.horaDelHecho1} A ${data.horaDelHecho2}`
          : data.horaDelHecho1;
      data.fechaDelHechoText = data.fechaDelHechoText1;
    }
    if (date != null && date2 != null) {
      //si ambos son distintos armamos un string con ambos
      data.fechaDelHecho = data.fechaDelHecho1 + " A " + data.fechaDelHecho2;
      data.horaDelHecho =
        data.horaDelHecho1 < data.horaDelHecho2
          ? `${data.horaDelHecho1} A ${data.horaDelHecho2}`
          : data.horaDelHecho1;
      data.fechaDelHechoText = [
        `${data.fechaDelHechoText1[0]} A ${data.fechaDelHechoText2[0]}`,
        `${data.fechaDelHechoText1[1]} A ${data.fechaDelHechoText2[1]}`,
      ];
    }
  } catch (e) {
    console.log("error", e);
  }

  try {
    let inputs = 0;
    let lugarHecho = "";
    let calleString = ""; //'sin calle';
    if (state.preUbicacion.calle) {
      calleString = state.preUbicacion.calle;
      lugarHecho = `Calle ${calleString}`;
      inputs++;
    }

    let numeroString = ""; //'sin numero';
    if (state.preUbicacion.numero) {
      numeroString = state.preUbicacion.numero;
      lugarHecho = lugarHecho + " Número: " + numeroString;
      inputs++;
    }

    // let dto = typeof state.preUbicacion.departamento == 'object' ? state.preUbicacion.departamento.nombre : false;
    let dto =
      typeof state.preUbicacion.departamento === "undefined" ||
      state.preUbicacion.departamento === null
        ? false
        : state.preUbicacion.departamento.nombre;

    let localidadString = ""; // 'sin localidad';
    if (dto) {
      localidadString = dto == "CAPITAL" ? "SAN JUAN" : dto;
      lugarHecho = inputs > 0 ? lugarHecho + ", " + localidadString : lugarHecho + localidadString;
      // lugarHecho = lugarHecho + ', '+ localidadString;
      inputs++;
    }

    let casaString = ""; //'sin casa';
    if (state.preUbicacion.casa) {
      casaString = state.preUbicacion.casa;
      lugarHecho = lugarHecho + " Casa: " + casaString;
      inputs++;
    }
    // let orientacion = typeof state.preUbicacion.orientacion == 'object' ? state.preUbicacion.orientacion.nombre : false;
    let orientacion =
      typeof state.preUbicacion.orientacion === "undefined" ||
      state.preUbicacion.orientacion === null
        ? false
        : state.preUbicacion.orientacion.nombre;
    let orientacionString = ""; // 'sin orientacion';

    if (orientacion) {
      orientacionString = orientacion;
      lugarHecho = lugarHecho + ", " + orientacionString;
      inputs++;
    }

    let barrioString = ""; //'sin barrio';
    if (state.preUbicacion.barrio) {
      barrioString = state.preUbicacion.barrio;
      lugarHecho =
        inputs > 0
          ? lugarHecho + ". Barrio: " + barrioString
          : lugarHecho + "Barrio: " + barrioString;
      // lugarHecho = lugarHecho + '. Barrio: ' + barrioString;
      inputs++;
    }
    let sectorString = ""; //'sin sector';
    if (state.preUbicacion.sector) {
      sectorString = state.preUbicacion.sector;
      lugarHecho = lugarHecho + " Sector: " + sectorString;
      inputs++;
    }

    let pisoString = ""; //'sin piso';
    if (state.preUbicacion.piso) {
      pisoString = state.preUbicacion.piso;
      lugarHecho = lugarHecho + " Piso: " + pisoString;
      inputs++;
    }

    let zonaString = ""; //'sin zona';
    if (state.preUbicacion.zona) {
      zonaString = state.preUbicacion.zona;
      lugarHecho = lugarHecho + ", Zona: " + zonaString;
      inputs++;
    }

    data.lugarHecho = {
      ...state.preUbicacion,
      text: lugarHecho,
    };
    data.lugarDelHecho = lugarHecho;
  } catch (e) {
    console.log("error", e);
  }

  ///////////////////////////Fecha de extencion del certificado///////////////
  let date = !state.fechaCertificadoDenuncia ? new Date() : state.fechaCertificadoDenuncia;

  if (typeof date == "string") {
    date = new Date(date); //Lo convertimos a tipo Date para luego porder aplicarle la funcion toLocaleDateString
  }

  ///////////////////////////////////Fecha de extencion del Certificado///////////////////
  data.fechaDeExtencionCertificado = date.toLocaleDateString("es-AR");

  data.fechaDeExtencionCertificadoText = functionsDataResumen.fechaLetras(date);

  //////////////////////////////////Fecha de extencion del certifcado +5 dias/////////////////////////////////////
  var fechaDeExtencionCertificadoMas5dias = functionsDataResumen.sumarDias(date, 5);
  data.fechaDeExtencionCertificadoMas5diasText = functionsDataResumen.fechaLetras(
    fechaDeExtencionCertificadoMas5dias
  );

  ///////////////////////////////Hora de extencion del certificado
  var hora = date.getHours() + " Horas y " + date.getMinutes() + " minutos";
  data.horaDeExtencionCertificado = hora;

  if (data.err < 1) data.validate = true;

  data.fechaAhoraText = functionsDataResumen.fechaLetras();
};
export default {
  datesAndLocations,
};
